<template>
   <div class="modelcover" @click="handleCloseCodeLogin">
     <div class="sigin" @click.stop="">
     		<div class="modal">
     			<div class="title flex">
     				验证码登录
     				<span class="flex1"></span>
     				<img src="../assets/img/pwdlogin.png" @click="handlePwdLogin()" style="cursor: pointer;" >
     			</div>
     			<div class="flex list" style="margin-top: 50px;">
     				<img src="../assets/img/usericon.png" width="19" height="20">
     				<input type="tel" maxlength="11" name="" id="" value="" placeholder="请输入手机号" v-model="phone" style="flex:1;" />
            <img :src="kaptchaPic" v-if="kaptchaPic" class="number" @click="getKaptcha"/>
     			</div>
          <div class="flex list">
            <img src="../assets/img/codeicon.png" width="19" height="20" >
          	<input maxlength="11"  v-model="kaptcha" placeholder="请输入运算结果">
          </div>
     			<div class="flex list">
     				<img src="../assets/img/codeicon.png" width="19" height="20" >
     				<input type="tel" name="" id="" value="" placeholder="请输入短信验证码" class="flex1" v-model="code" />
     				<span style="color: #4fa7ff;cursor: pointer;" v-if="canget" @click="handleGetCode()">获取验证码</span>
            <span style="color: #4fa7ff;cursor: pointer;" v-else>{{seconds}}s</span>
     			</div>
     	<!-- 		<div class="flex list">
     				<img src="../img/passwordicon.png" width="18" height="20" >
     				<input type="tel" name="" id="" value="" placeholder="请输入密码" />
     			</div> -->
     	<!-- 		<div class="flex" style="justify-content: space-between;margin-top: 15px;">
     				<span style="color: #4fa7ff;">忘记密码?</span>
     				<span style="color: #4fa7ff;">立即注册</span>
     			</div> -->
     			<div class="btn" style="cursor: pointer;" @click="handleSubmit()">
     				登录
     			</div>

     		</div>
     </div>
   </div>
</template>

<script>
  var timer;
  export default {
    name: 'Footer',
    components:{

    },
    data () {
      return {
          showLogin:false,
          loginType: 1, //
          phone: '',
          code:'',
          uuid:'',
          seconds:60,
          canget:true,
          kaptchaPic:'',
          kaptcha:'',
      }
    },
    watch: {
    	phone(val) {

    		if (val.length == 11) {
    			this.getKaptcha();
    		}
    	}
    },
    methods:{
      getKaptcha() { // 获取图形验证码
      	this.kaptchaPic = 'http://app.pstedu.com/api/login/kaptcha?phone='+this.phone+'&t='+new Date().getTime()
      },
      handleCloseCodeLogin(){
        this.$emit('handleCloseCodeLogin')
      },
      handleGetCode(){
        if(!/^1\d{10}$/.test(this.phone)){

          alert('请输入正确的手机号码');
          return ;
        }
        if(!this.kaptcha){
          alert('请输入图片验证码结果');
          return;
        }
        let data=new FormData();
            data.append('phone',this.phone);
            data.append('kaptcha',this.kaptcha)
            data.append('templateType',1);
        this.$axios.post(this.$common.sendSMS_url,data).then((res)=>{
              console.log(res)
              if(res.data.code==1){
                  this.canget=false;
                  this.uuid=res.data.data;
                  timer=setInterval(()=>{
                    if(this.seconds==0){
                      clearInterval(timer);
                      this.canget=true;
                      this.seconds=60
                    }
                    else {
                      this.seconds--;
                    }
                  },1000)

              }
              else {

              }
        }).catch((res)=>{


        })
      },
      handlePwdLogin(){
        this.$emit('handlePwdLogin')
      },
      handleSubmit(){
        if(!/^1\d{10}$/.test(this.phone)){

          alert('请输入正确的手机号码');
          return ;
        }
        if(!/^\d{6}$/.test(this.code)){

          alert('请输入6位验证码');
          return ;
        }
        let data=new FormData();
            data.append('phone',this.phone);
            data.append('code',this.code);
            data.append('uuid',this.uuid);
            data.append('loginType',1);
        this.$axios.post(this.$common.login_url,data).then((res)=>{
              if(res.data.code==1){
                window.sessionStorage.token=res.data.data;
                this.phone='';
                this.code=''
                this.$emit('codeLogined')
              }
              else {
                alert(res.data.msg)
              }
        })
      }
    }
  }
</script>

<style scoped="">
  .modelcover {
    width: 100%;
        height: 100%;
        background-color: rgba(34, 34, 34, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        top: 0;
        position: fixed;
        left: 0;
        z-index: 1988;
  }
  .sigin {
  	width: 390px;
  	    height: 430px;
  	    border-radius: 10px;
  	    background-color: rgba(255, 255, 255, 1);
  	    position: relative;
  		padding: 30px;
  }
  .sigin .title {
  	font-size: 24px;
  }
  .sigin input {
  	border: none;
  	line-height: 40px;
  	outline: none;
  	text-indent: 15px;
  	font-size: 16px;
  }
  .sigin .list {
  	border-bottom: 1px solid #eee;
  	align-items: center;
  	margin-top: 15px;
  }
  .sigin .btn {
  	height: 50px;
  	text-align: center;
  	line-height: 50px;
  	color: #fff;
  	background-color: #4fa7ff;
  	border-radius: 4px;
  	margin-top: 80px;
  	font-size: 18px;
  }
  .number {
    height: 40px;
    width: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/components/codelogin.vue